import { render, staticRenderFns } from "./DropdownV2.vue?vue&type=template&id=063a3585&"
import script from "./DropdownV2.vue?vue&type=script&lang=js&"
export * from "./DropdownV2.vue?vue&type=script&lang=js&"
import style0 from "./DropdownV2.vue?vue&type=style&index=0&id=063a3585&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../Breeze.Kiosk.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports